<template>
  <v-scale-transition>
    <v-alert
      v-if="shouldShow"
      :type="isGettingClose ? 'warning' : 'info'"
      variant="outlined"
      border="start"
    >
      You have until
      <c-display
        :model="purchase"
        for="expirationDate"
        format="h:mm a"
      ></c-display>

      <template v-if="isFutureExpiration">
        (
        <c-display
          :model="purchase"
          for="expirationDate"
          :key="'fromnow-' + now.valueOf()"
          :format="{ distance: true, addSuffix: false }"
        ></c-display>
        )
      </template>
      to complete your purchase.
    </v-alert>
  </v-scale-transition>
</template>

<script setup lang="ts">
import { TicketPurchaseDtoViewModel } from "@/viewmodels.g";
import { differenceInMinutes, addMinutes } from "date-fns";
import { computed, onUnmounted, ref } from "vue";

const now = ref(new Date());
const intervalId = setInterval(() => (now.value = new Date()), 10000);

const props = defineProps<{
  purchase: TicketPurchaseDtoViewModel;
}>();

watch(
  () => now.value,
  () => {
    if (
      props.purchase.expirationDate &&
      //add 1 minute because the front end can be a few seconds ahead of the back end
      addMinutes(props.purchase.expirationDate, 1) <= now.value
    ) {
      //this will display the expiration notice
      window.location.reload();
    }
  },
);

const isFutureExpiration = computed(() => {
  return (
    props.purchase.expirationDate && props.purchase.expirationDate > now.value
  );
});

const isGettingClose = computed(() => {
  if (!props.purchase.expirationDate) {
    return null;
  }
  return differenceInMinutes(props.purchase.expirationDate, now.value) <= 3;
});

const shouldShow = computed(() => {
  return (
    props.purchase.expirationDate != null && props.purchase.tickets?.length
  );
});

onUnmounted(() => {
  clearInterval(intervalId);
});
</script>
